<template>
    <div class="group-box">
        <div class="title-bar">
            <p>小组评价</p>
        </div>
        <div ref="groupContent" class="group-content">
            <div v-if="hintData == 'start'" class="hint-box">
                <div class="hint-content">
                    <img :src="groupIcon" alt="">
                    <p>{{ hintContent }}</p>
                </div>
            </div>

            <div v-else="" class="group-menber">
                <p class="group-menber-title">请开始你的表演，并等待老师评分</p>
                <div class="group-menber-result">
                    <div v-for="(item,index) in teamMembers" :id="'result-box-' + item.id" :key="index.id" class="group-menber-result-user">
                        <div class="user-avatar">
                            <img :src="item.avatarUrl == null ? avatarUrl : item.avatarUrl" alt="">
                            <div v-show="item.score !== undefined" :class=" item.score < 0 ? 'negative' : '' " class="score">{{ item.score }}</div>
                        </div>
                        <p class="group-name">{{ item.fullName }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import groupIcon from '@/assets/image/group_icon.png';
import avatarUrl from '@/assets/image/user-avatarUrl.jpg';
import Wings from '../assets/scripts/wings.js';

export default {
    props: {
        isLock: {
            type: Boolean,
            default: false
        },
        currentShow: {
            type: String,
            default: ''
        }
    },

    data: function() {
        return {
            groupIcon: groupIcon,
            avatarUrl: avatarUrl,
            hintContent: '还没有幸运小组被选中',
            supportedEventNames: [
                'crp.groupEvaluate.start',
                'crp.groupEvaluate.chosenGroup',
                'crp.groupEvaluate.removeMember',
                'crp.groupEvaluate.setScore',
                'crp.groupEvaluate.end',
                'common.moveJoystick'],
            hintData: 'start',
            clazzCourseId: null,
            teamMembers: [],
            wings: null,
        };
    },

    watch: {
        currentShow: function (newVal, oldVal) {
            // the stage is hiding me
            if (newVal !== this.componentId && oldVal === this.componentId) {
                this.teamMembers = [];
                if (this.$refs.groupContent) this.$refs.groupContent.scrollTop = 0;
                this.wings.hideAnimation();
            }
        }
    },


    created: function() {
        this.wings = new Wings();
    },

    mounted: function() {
        this.componentId = this.$attrs.id;
        window.addEventListener('message', this.windowMessageHandler);
    },

    destroyed: function() {
        window.removeEventListener('message', this.windowMessageHandler);
        this.componentId = null;
    },

    
    methods: {
        windowMessageHandler: function(e) {
            const msg = e.data;
            if ( ! msg) return;
            if ( ! msg.eventName || this.supportedEventNames.indexOf(msg.eventName) === -1) return;

            const msgData = msg.data;
            // console.log(msgData);
            switch (msg.eventName) {
                case 'crp.groupEvaluate.start':
                    this.crpGroupEvaluateStart(msgData);
                    break;
                case 'crp.groupEvaluate.chosenGroup':
                    if (msgData.clazzCourseId !== this.clazzCourseId) return;
                    this.crpGroupEvaluateChosenGroup(msgData);
                    break;
                case 'crp.groupEvaluate.removeMember':
                    this.crpGroupEvaluateRemoveMember(msgData);
                    break;
                case 'crp.groupEvaluate.setScore':
                    if (msgData.clazzCourseId !== this.clazzCourseId) return;
                    this.crpGroupEvaluateSetScore(msgData);
                    break;
                case 'crp.groupEvaluate.end':
                    this.crpGroupEvaluateEnd();
                    break;
                case 'common.moveJoystick':
                    if (this.componentId) this.moveJoystick(msgData);
                    break;
                default:
                    // statements_def
                    break;
            }
        },

        crpGroupEvaluateStart: function(msgData) {
            this.hintData = 'start';
            this.clazzCourseId = msgData.clazzCourseId;
        },

        crpGroupEvaluateChosenGroup: function(msgData) {
            console.log(msgData);
            this.hintData = 'hasData';
            this.teamMembers = msgData.teamMembers;
        },

        crpGroupEvaluateRemoveMember: function(msgData) {
            let index = this.teamMembers.findIndex(t => t.id === msgData.removeMemberId);
            this.teamMembers.splice(index,1);
        },

        crpGroupEvaluateSetScore: function(msgData) {
            msgData.chosenMembers.forEach(c => {
                let index = this.teamMembers.findIndex(ele => ele.id === c.id);
                let sameScore = false;
                if (this.teamMembers[index].score === c.score) sameScore = true;
                this.teamMembers[index].score = c.score;
                this.$set(this.teamMembers,index,this.teamMembers[index]);
                
                if (sameScore) return;
                const avatar = document.querySelector('#result-box-' + this.teamMembers[index].id).querySelector('.user-avatar > img');
                this.wings.pushAnimation(avatar, this.teamMembers[index].fullName, this.teamMembers[index].score);
            });
        },

        moveJoystick: function(msgData) {
            let direction = msgData.direction;
            let groupContent = this.$refs.groupContent;

            if (this.hintData == 'start') return;
            if (direction === 'LEFT') {
                return;
            } else if (direction === 'RIGHT') {
                return;
            } else if (direction === 'UP') {
                groupContent.scrollTop -= 40;
            } else if (direction === 'DOWN') {
                groupContent.scrollTop += 40;
            } else {
                return;
            }

        },

        crpGroupEvaluateEnd: function() {
            this.wings.hideAnimation();
        },

    }
};
</script>

<style scoped>
    .group-box {
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
    }

    .title-bar {
        width: 100%;
        display: flex;
        height: 80px;
        background-color: #191919;
        justify-content: center;
        align-items: center;
        position: fixed;
        top: 0;
        left: 0;
        z-index: 99;
    }

    .title-bar p {
        font-size: 24px;
        color: #ffffff;
        text-align: center;
        width:600px;
    }

    .group-content{
        width: 100%;
        height: calc(100% - 80px);
        margin-top: 80px;
        box-sizing: border-box;
        display: flex;
        flex: 2;
        flex-direction: column;
        overflow-y: auto;
    }

    .hint-box {
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        flex: 1;
    }
    
    .hint-content {
        display: flex;
        align-items: center;
        font-size: 24px;
        color: #e8e8e8;
        align-items: center;
        flex-direction: column;
        margin-top: -80px;
    }

    .hint-content img {
        width: 200px;
        height: 200px;
    }

    .group-menber {
        width: 100%;
        /* height: 100%; */
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        /* padding: 0 60px; */
        box-sizing: border-box;
    }

    .group-menber-result {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-wrap: wrap;
    }

    .group-menber-result > div {
        width: 240px;
        margin: 30px 0;
        display: flex;
        align-items: center;
        flex-direction: column;
    }

    .user-avatar {
        width: 200px;
        height: 200px;
        box-sizing: border-box;
        border-radius: 50%;
        overflow: hidden;
        position: relative;
    }

    .user-avatar img {
        width: 100%;
        height: 100%;
        border-radius: 50%;
        box-sizing: border-box;
        border: 6px solid #ffffff;
    }

    .score {
        width: 200px;
        padding: 50px 0 20px 0;
        background-image: url("../assets/image/score.png");
        background-repeat: no-repeat;
        background-size: 200px 100px;
        position: absolute;
        bottom: 0;
        left: 0;
        text-align: center;
        font-size: 30px;
        line-height: 30px;
        color: #ffffff;
    }

    .negative {
        background-image: url("../assets/image/negative.png");
        background-size: 200px 100px;
    }

    .group-menber-result-user p {
        max-width: 200px;
        font-size: 24px;
        color: #CCCCCC;
        text-align: center;
        margin-top: 20px;
        overflow: hidden; 
        text-overflow: ellipsis;
        display: -webkit-box; 
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1; 
    }

    .group-menber-title {
        font-size: 24px;
        color: #e8e8e8;
        padding: 60px 0 30px 0;
    }
</style>
